"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWidgetContext_1 = require("../../../common/react/useWidgetContext");
var useAppContext_1 = require("../../../common/react/useAppContext");
var usePlatformConfig_1 = require("../../../common/react/usePlatformConfig");
var SummaryCarView_1 = require("../../../summary/components/summaryViews/SummaryCarView");
var EnquiryFormVehicleSummary = function () {
    var _a;
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var platformConfig = usePlatformConfig_1.default();
    var _b = useAppContext_1.default(), carConfig = _b.carConfig, deal = _b.deal;
    var _c = platformConfig.platformConfig, priceDisplay = _c.priceDisplay, complexModel = _c.platformFeatures.complexModel;
    return (<SummaryCarView_1.default complexModel={complexModel} carConfiguration={carConfig} financeQuote={(_a = deal) === null || _a === void 0 ? void 0 : _a.financeQuote} priceDisplay={priceDisplay} dimensions={dimensions}/>);
};
exports.default = EnquiryFormVehicleSummary;
